import React from "react";
import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function CardAction({
  label,
  body,
  action,
  className,
}: {
  label: string;
  body: string;
  action: React.ReactNode;
  className?: string;
}) {
  return (
    <Card radius="lg" className={cn("border-border border", className)}>
      <CardContent className="flex flex-row items-center gap-2 p-3">
        <View className="flex flex-1 flex-col gap-1">
          <Typography variant="label-sm" numberOfLines={1}>
            {label}
          </Typography>
          <Typography variant="body-sm" color="foreground-intermediate">
            {body}
          </Typography>
        </View>
        {action}
      </CardContent>
    </Card>
  );
}
